// prop-types is a library for typechecking of props
// import PropTypes from "prop-types";

const comprehensive = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "Do you add any commissions on your prices?",
      answer:
        "No, the motor vehicle insurance quotes you see are the lowest rates negotiated from our panel of insurance companies in Kenya. These are exclusive motor insurance rates and you may not get them elsewhere in Kenya.",
    },
    {
      icon: "hdr_weak",
      question: "Can I pay the premiums in installments?",
      answer:
        "If it's not possible to pay the full premiums in full, you may pay 50% of the premiums, the provider will issue a 1 month policy which is then extended when you complete the payment. In addition we can arrange an insurance premium financing, on this scheme, you pay a small cost to get financing from an institution.",
    },
    {
      icon: "hdr_strong",
      question: "Can I get a courtesy car in case my car is in the garage?",
      answer:
        "Yes, some of our packages include a courtesy car. For others, you can add this optional benefit along with other benefits like personal accident cover, extra limits for windscreen damage and radio cassettle damage.",
    },
    {
      icon: "hdr_weak",
      question: "Do I need the valuation of my car?",
      answer:
        "Yes, valuation of the vehicle is required to complete the car insurance policy. On your quote for car insurance, we will use the closest known market value of the vehicle and once the cover is placed, we will issue a valuation slip which you can use to command a FREE valuation at the appointed valuation outlet.",
    },
    {
      icon: "hdr_strong",
      question: "What's covered on this policy?",
      answer:
        "This policy will cover fire, theft, accidental damage to the vehicle. We advise that you include an excess protector and political violence cover to your policy to make it fully comprehensive.",
    },
    {
      icon: "hdr_weak",
      question: "What if I have more than one car?",
      answer:
        "Congratulations, you might be able to qualify for a discount on your car insurance by taking out a multi car policy. Most insurers give discounts to owners of fleets(more than 2 cars). Are you good driver? If you have a low claims ratio, you could qualify for a further discount on your car insurance quote in Kenya.",
    },
    {
      icon: "hdr_strong",
      question: "Will you handle my claims? How long does it take?",
      answer:
        "Yes, our claims team will assist you in the unfortunate event that you have a claim. For small claims, you can expect to have it processed in less than 5 working days if it's been fully documented. Rest assured, our team will make sure you are back on the road as quickly as possible.",
    },
    {
      icon: "hdr_weak",
      question: "What documents do I need ?",
      answer:
        "After reviewing and agreeing to your online quote for motor insurance, ee will need a copy of your National ID/Passport, driving licennce and logbook of the vehicle in order to place your car insurance. These are required for Know Your Client (KYC), mandated by financial regulation in Kenya.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare all the rates",
        description: "Compare all the rates from leading providers",
      },
      {
        icon: "filter_2",
        title: "NO commissions!",
        description: "NO commissions!",
      },
      {
        icon: "filter_3",
        title: " Save money",
        description: " Save money on your annual premiums",
      },
      {
        icon: "filter_4",
        title: "BUY Online",
        description: "BUY Online instantly.",
      },
      {
        icon: "filter_5",
        title: " Get your sticker delivered",
        description: " Get your sticker delivered same day in Nairobi.",
      },
      {
        icon: "filter_6",
        title: "NO queues, NO Forms, NO Hassles",
        description: "NO queues, NO Forms, NO Hassles.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE & BUY CAR INSURANCE ONLINE",
      description:
        "Comprehensive car insurance protects you from costs arising out of third party damage, bodily injury, theft and damage to you car. Choosing best insurance cover can be confusing but we have made it quick and easy, compare all the rates, benefits, excess online.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Start a Quote",
    },
  },
};

const thirdPartyOnly = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "Will this insurance cover my vehicle?",
      answer:
        "No, this TPO insurance will only cover third parties for property damages and bodily injuries and any other liabilities and not the insured vehicle or person. To cover damage, fire and theft, please choose the comprehensive motor insurance cover.",
    },
    {
      icon: "hdr_weak",
      question: "When should I buy TPO cover?",
      answer:
        "In some cases, it more advisable to buy a Third Party Only (TPO) vehicle insurance in Kenya compared to the Comprehensive car insurance. It is advisable to buy a TPO cover if your car value is below KSh 300,000. Most insurers will not take this on board for comprehensive cover. In addition, some religions recommend TPO e.g. Islam which encourages member to take Sharia compliant financial products and services.",
    },
    {
      icon: "hdr_strong",
      question: "How can I choose a good insurance company?",
      answer:
        "You can view the motor insurance quotes online and pick a company of your choice. All the providers on our panel are trusted and guarantee a high quality of service.",
    },
    {
      icon: "hdr_weak",
      question: "Are the premiums annual?",
      answer:
        "Yes the premiums are annual premiums, payable in one instalment. Multiple instalments may attract a processing fee which is charged by the insurance company.",
    },
    {
      icon: "hdr_strong",
      question: "Will you assist in case of queries, concerns and claims?",
      answer:
        "Yes, our team of insurance advisors will be able to assist you for any questions about your motor vehicle insurance. Should you have a claim, concern or question, don't worry, we are always here to help.",
    },
    {
      icon: "hdr_weak",
      question: "Can I get my insurance sticker immediately?",
      answer:
        "Yes, we will deliver your motor insurance sticker same day in Nairobi and within 24 hrs for clients outside Nairobi.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare",
        description: "Compare top insurance companies in Kenya.",
      },
      {
        icon: "filter_2",
        title: "Save time and money",
        description: "Save time and money, buy your insurance online.",
      },
      {
        icon: "filter_3",
        title: "Get your insurance delivered",
        description:
          "Get your car insurance sticker delivered to your doorstep in Nairobi.",
      },
      {
        icon: "filter_4",
        title: "NO queues, NO Forms, NO Hassles",
        description: "NO queues, NO Forms, NO Hassles.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE & BUY YOUR TPO CAR INSURANCE ONLINE",
      description:
        "Third Party Only (TPO) car insurance protects you from costs arising out of damage to third party property and injuries to third party persons injury. Finding the best insurance cover can be confusing but we have made it quick and easy, compare all the rates, benefits, excess costs online and buy online instantly.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Start a Quote",
    },
  },
};

const motorCycleInsurance = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "Will this insurance cover my vehicle?",
      answer:
        "No, this TPO insurance will only cover third parties for property damages and bodily injuries and any other liabilities and not the insured vehicle or person. To cover damage, fire and theft, please choose the comprehensive motor insurance cover.",
    },
    {
      icon: "hdr_weak",
      question: "When should I buy TPO cover?",
      answer:
        "In some cases, it more advisable to buy a Third Party Only (TPO) vehicle insurance in Kenya compared to the Comprehensive car insurance. It is advisable to buy a TPO cover if your car value is below KSh 300,000. Most insurers will not take this on board for comprehensive cover. In addition, some religions recommend TPO e.g. Islam which encourages member to take Sharia compliant financial products and services.",
    },
    {
      icon: "hdr_strong",
      question: "How can I choose a good insurance company?",
      answer:
        "You can view the motor insurance quotes online and pick a company of your choice. All the providers on our panel are trusted and guarantee a high quality of service.",
    },
    {
      icon: "hdr_weak",
      question: "Are the premiums annual?",
      answer:
        "Yes the premiums are annual premiums, payable in one instalment. Multiple instalments may attract a processing fee which is charged by the insurance company.",
    },
    {
      icon: "hdr_strong",
      question: "Will you assist in case of queries, concerns and claims?",
      answer:
        "Yes, our team of insurance advisors will be able to assist you for any questions about your motor vehicle insurance. Should you have a claim, concern or question, don't worry, we are always here to help.",
    },
    {
      icon: "hdr_weak",
      question: "Can I get my insurance sticker immediately?",
      answer:
        "Yes, we will deliver your motor insurance sticker same day in Nairobi and within 24 hrs for clients outside Nairobi.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare rates.",
        description: "Compare all the rates from leading providers.",
      },
      {
        icon: "filter_2",
        title: "NO commissions!",
        description: "NO commissions!",
      },
      {
        icon: "filter_3",
        title: "Save money",
        description: "Save money on your annual premiums.",
      },
      {
        icon: "filter_4",
        title: "BUY Online",
        description: "BUY Online instantly.",
      },
      {
        icon: "filter_5",
        title: "NO queues, NO Forms, NO Hassles",
        description: "NO queues, NO Forms, NO Hassles.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "MOTOR CYCLE INSURANCE",
      description:
        "The number of motorcycles on Kenyan roads has exploded over the last 5 years becoming an affordable and popular mode of transport. The majority of motorcycles are PSV motorcycles, commercial and lastly private motorcycles. However, compared to many other mid income countries, the proliferation of motor cycles still remains very low as Kenyans continue to embrace affordable second hand motor vehicles from Japan. The motorcycle insurance market in Kenya consequently very small, owes to the high loss nature from road accidents and robbery or theft. A limited number of insurance companies offer motorcycle insurance in Kenya. Due to the size and value of the motorcycle industry in Kenya, alongside the high risk and loss nature of the business, most insurance companies don’t offer motor cycle insurance. A few insurers offer insurance for private and commercial motor cycles and less than 5 insurance companies offer insurance cover for the PSV boda boda market, the most risky segment of the motorcycle market.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Get a Quote",
    },
  },
};

const psvBodaBodaData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "Will this insurance cover my vehicle?",
      answer:
        "No, this TPO insurance will only cover third parties for property damages and bodily injuries and any other liabilities and not the insured vehicle or person. To cover damage, fire and theft, please choose the comprehensive motor insurance cover.",
    },
    {
      icon: "hdr_weak",
      question: "When should I buy TPO cover?",
      answer:
        "In some cases, it more advisable to buy a Third Party Only (TPO) vehicle insurance in Kenya compared to the Comprehensive car insurance. It is advisable to buy a TPO cover if your car value is below KSh 300,000. Most insurers will not take this on board for comprehensive cover. In addition, some religions recommend TPO e.g. Islam which encourages member to take Sharia compliant financial products and services.",
    },
    {
      icon: "hdr_strong",
      question: "How can I choose a good insurance company?",
      answer:
        "You can view the motor insurance quotes online and pick a company of your choice. All the providers on our panel are trusted and guarantee a high quality of service.",
    },
    {
      icon: "hdr_weak",
      question: "Are the premiums annual?",
      answer:
        "Yes the premiums are annual premiums, payable in one instalment. Multiple instalments may attract a processing fee which is charged by the insurance company.",
    },
    {
      icon: "hdr_strong",
      question: "Will you assist in case of queries, concerns and claims?",
      answer:
        "Yes, our team of insurance advisors will be able to assist you for any questions about your motor vehicle insurance. Should you have a claim, concern or question, don't worry, we are always here to help.",
    },
    {
      icon: "hdr_weak",
      question: "Can I get my insurance sticker immediately?",
      answer:
        "Yes, we will deliver your motor insurance sticker same day in Nairobi and within 24 hrs for clients outside Nairobi.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare rates.",
        description: "Compare all the rates from leading providers.",
      },
      {
        icon: "filter_2",
        title: "NO commissions!",
        description: "NO commissions!",
      },
      {
        icon: "filter_3",
        title: "Save money",
        description: "Save money on your annual premiums.",
      },
      {
        icon: "filter_4",
        title: "BUY Online",
        description: "BUY Online instantly.",
      },
      {
        icon: "filter_5",
        title: "NO queues, NO Forms, NO Hassles",
        description: "NO queues, NO Forms, NO Hassles.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "PSV BODA BODA*",
      description:
        "The number of motorcycles on Kenyan roads has exploded over the last 5 years becoming an affordable and popular mode of transport. The majority of motorcycles are PSV motorcycles, commercial and lastly private motorcycles. However, compared to many other mid income countries, the proliferation of motor cycles still remains very low as Kenyans continue to embrace affordable second hand motor vehicles from Japan. The motorcycle insurance market in Kenya consequently very small, owes to the high loss nature from road accidents and robbery or theft. A limited number of insurance companies offer motorcycle insurance in Kenya. Due to the size and value of the motorcycle industry in Kenya, alongside the high risk and loss nature of the business, most insurance companies don’t offer motor cycle insurance. A few insurers offer insurance for private and commercial motor cycles and less than 5 insurance companies offer insurance cover for the PSV boda boda market, the most risky segment of the motorcycle market.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Get a Quote",
    },
  },
};

const motorPsv = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "Will this insurance cover my vehicle?",
      answer:
        "No, this TPO insurance will only cover third parties for property damages and bodily injuries and any other liabilities and not the insured vehicle or person. To cover damage, fire and theft, please choose the comprehensive motor insurance cover.",
    },
    {
      icon: "hdr_weak",
      question: "When should I buy TPO cover?",
      answer:
        "In some cases, it more advisable to buy a Third Party Only (TPO) vehicle insurance in Kenya compared to the Comprehensive car insurance. It is advisable to buy a TPO cover if your car value is below KSh 300,000. Most insurers will not take this on board for comprehensive cover. In addition, some religions recommend TPO e.g. Islam which encourages member to take Sharia compliant financial products and services.",
    },
    {
      icon: "hdr_strong",
      question: "How can I choose a good insurance company?",
      answer:
        "You can view the motor insurance quotes online and pick a company of your choice. All the providers on our panel are trusted and guarantee a high quality of service.",
    },
    {
      icon: "hdr_weak",
      question: "Are the premiums annual?",
      answer:
        "Yes the premiums are annual premiums, payable in one instalment. Multiple instalments may attract a processing fee which is charged by the insurance company.",
    },
    {
      icon: "hdr_strong",
      question: "Will you assist in case of queries, concerns and claims?",
      answer:
        "Yes, our team of insurance advisors will be able to assist you for any questions about your motor vehicle insurance. Should you have a claim, concern or question, don't worry, we are always here to help.",
    },
    {
      icon: "hdr_weak",
      question: "Can I get my insurance sticker immediately?",
      answer:
        "Yes, we will deliver your motor insurance sticker same day in Nairobi and within 24 hrs for clients outside Nairobi.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare rates.",
        description: "Compare all the rates from leading providers.",
      },
      {
        icon: "filter_2",
        title: "NO commissions!",
        description: "NO commissions!",
      },
      {
        icon: "filter_3",
        title: "Save money",
        description: "Save money on your annual premiums.",
      },
      {
        icon: "filter_4",
        title: "BUY Online",
        description: "BUY Online instantly.",
      },
      {
        icon: "filter_5",
        title: "NO queues, NO Forms, NO Hassles",
        description: "NO queues, NO Forms, NO Hassles.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "MOTOR PSV*",
      description:
        "The number of motorcycles on Kenyan roads has exploded over the last 5 years becoming an affordable and popular mode of transport. The majority of motorcycles are PSV motorcycles, commercial and lastly private motorcycles. However, compared to many other mid income countries, the proliferation of motor cycles still remains very low as Kenyans continue to embrace affordable second hand motor vehicles from Japan. The motorcycle insurance market in Kenya consequently very small, owes to the high loss nature from road accidents and robbery or theft. A limited number of insurance companies offer motorcycle insurance in Kenya. Due to the size and value of the motorcycle industry in Kenya, alongside the high risk and loss nature of the business, most insurance companies don’t offer motor cycle insurance. A few insurers offer insurance for private and commercial motor cycles and less than 5 insurance companies offer insurance cover for the PSV boda boda market, the most risky segment of the motorcycle market.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Get a Quote",
    },
  },
};

// Typechecking props for the seniorHealthData
// seniorHealthData.propTypes = {
//   faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
// };
// seniorHealthData.information.listInformation.propTypes = {
//   faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
// };
// seniorHealthData.information.cardInformation.propTypes = {
//   faqs: PropTypes.object,
// };
// adultHealthData.propTypes = {
//   faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
// };
// adultHealthData.information.listInformation.propTypes = {
//   faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
// };
// adultHealthData.information.cardInformation.propTypes = {
//   faqs: PropTypes.object,
// };

export {
  comprehensive,
  thirdPartyOnly,
  motorCycleInsurance,
  psvBodaBodaData,
  motorPsv,
};
